import { useSortable } from '@dnd-kit/sortable';
import { ReactElement } from 'react';
import { styled } from '@mui/material/styles';
import { Icon, IconTypes } from '../../../../../components/Icon';
import { theme } from '../../../../../theme';
import { SelectItem } from '../../../../../types';
import { useColumnSelector } from '../../../providers/ColumnSelectorProvider';
import { ColumnItemDropdown } from './ColumnItemDropdown';

const Container = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  height: 28px;
`;

const DragIconWrapper = styled('div')`
  margin-bottom: -2px;
  margin-top: 6px;
`;

const IconWrapper = styled('div')`
  cursor: pointer;
  margin-top: 4px;
`;

interface Props {
  column: SelectItem;
}

export const SelectedColumnItem = ({ column }: Props): ReactElement => {
  const locked = false;
  const { activeOrder, setActiveOrder } = useColumnSelector();
  const { attributes, listeners } = useSortable({ id: column.id as string });

  const onRemoveColumn = () => {
    const newSelectedColumns = activeOrder.filter((c) => c !== column.id);
    setActiveOrder(newSelectedColumns);
  };

  return (
    <Container>
      <DragIconWrapper {...attributes} {...listeners}>
        <Icon type={IconTypes.DRAG} color={theme.colors.neutral[30]} />
      </DragIconWrapper>
      <ColumnItemDropdown locked={locked} column={column} />
      <IconWrapper onClick={!locked ? onRemoveColumn : undefined}>
        {!locked ? (
          <Icon type={IconTypes.CLOSE_MENU_2} color={theme.colors.neutral[60]} />
        ) : (
          <Icon type={IconTypes.LOCK} color={theme.colors.neutral[60]} />
        )}
      </IconWrapper>
    </Container>
  );
};
